import Vue from 'vue'
import _ from 'lodash'

export default function (app) {
  window._ = app.$_ = _
  Vue.use(() => {
    Object.defineProperties(Vue.prototype, {
      $_: {
        get () {
          return _
        }
      }
    })
  })
}
